import { type GetLensCategoryListResponse, type MyLensesLensCategory } from "../../gql-generated/types";

const generateObjectMap = (
    categoryList: readonly MyLensesLensCategory[],
    customMapper: (category: [string, MyLensesLensCategory]) => [string, MyLensesLensCategory] = (c) => c,
) => {
    return Object.fromEntries(Object.entries(categoryList).map(([_, obj]) => customMapper([obj.id ?? "", obj])));
};

export const mapLensCategoryMap = (
    lensCategoryList: GetLensCategoryListResponse["lensCategoryList"],
): Record<string, MyLensesLensCategory> => {
    if (!lensCategoryList) {
        return {};
    }

    const { parentLensCategoriesList, subLensCategoriesList } = {
        parentLensCategoriesList: lensCategoryList.parentLensCategoriesList,
        subLensCategoriesList: lensCategoryList.subLensCategoriesList,
    };

    const parentMap = generateObjectMap(parentLensCategoriesList);

    const subMap = generateObjectMap(subLensCategoriesList, ([id, category]) => {
        const parent = category.parentId ? parentMap[category.parentId] : null;

        return [
            id,
            {
                ...category,
                displayName: parent ? `${parent.displayName} - ${category.displayName}` : category.displayName,
            },
        ];
    });

    return { ...parentMap, ...subMap };
};
